import axios from "axios";

const instance = axios.create({
  baseURL: "https://react-burger-14006-default-rtdb.firebaseio.com/",
});
export default instance;
